<div class="auto-group-sources-container mt-20">
  <div class="auto-group-sources-label">{{'new_group_settings.auto_group_filters.label' | translate}}</div>
  <auto-group-filter-item *ngFor="let filter of autoGroupFilters;"
                          [supportedFilterOptions]="availableFilterTypeOptions"
                          [autoGroupFilter]="filter"
                          (changeGroupFilterEvent)="onChangeGroupFilter($event)"
                          (deleteGroupFilterEvent)="deleteGroupFilterEvent($event)"
                          (changePlatformFilterEvent)="onChangePlatform($event)">
  </auto-group-filter-item>
  <div class="add-btn-container">
    <a class="add-btn" (click)="addMoreGroupFilter()">
      <img src="/assets/images/Plus_Dark.svg" >
    </a>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filters/auto-group-filters.component.html